import { useEstimateStore } from '@talon/web/src/context';
import { Box, Button, Heading, Text, Tip } from 'grommet';
import { Table } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddNewButton, CreateEstimateModal, Delete } from '..';

export interface IEstimateListProps {
  gridArea?: string;
}

export const EstimateList = observer(({ gridArea }: IEstimateListProps) => {
  /** Context **/
  const estimateStore = useEstimateStore();
  const navigate = useNavigate();

  /** State **/
  const [showModal, setShowModal] = useState(false);
  const [creating, setCreating] = useState(false);

  /** Methods **/

  const deleteEstimate = async (id: string) => {
    await estimateStore.deleteEstimate(id);
  };

  /** Render **/
  return (
    <Box
      direction="column"
      pad="medium"
      overflow={{ vertical: 'auto' }}
      align="start"
      id="Estimate-list"
      gridArea={gridArea}
    >
      <Box direction="row">
        <Heading level="3" margin="medium">
          Estimates
        </Heading>
        <AddNewButton disabled={creating} onClick={() => setShowModal(true)} tipText="New Estimate" icon={<Table />} />
      </Box>
      {estimateStore.estimateList
        ?.filter((estimate) => !estimate.is_hidden)
        .map((e) => (
          <Box direction="row" key={e.id}>
            <Tip
              content={
                <Box
                  width={{ max: 'medium' }}
                  background="light-2"
                  round="small"
                  pad="small"
                  margin="small"
                  border="all"
                >
                  <Text>{e.title}</Text>
                </Box>
              }
              plain={true}
            >
              <Button
                pad="small"
                margin="small"
                hoverIndicator
                onClick={() => navigate(e.id)}
                label={e.title.length > 35 ? `${e.title.slice(0, 34)}...` : e.title}
                active={e.id === estimateStore.currentEstimate?.id}
              />
            </Tip>
            <Delete onClick={() => deleteEstimate(e.id)} name={e.title} />
          </Box>
        ))}
      {!estimateStore.estimateList?.length && <Text>No previous Estimates found for this project.</Text>}
      {showModal && <CreateEstimateModal creating={creating} setCreating={setCreating} setShowModal={setShowModal} />}
    </Box>
  );
});
